import { action, computed, observable } from "mobx";
import { ViewModelBase } from "Core/ViewModels/ViewModelBase";
import { EmailModel } from "Custom/Models/Domain/ProductSelector/Email";
import { validate, ValidationError } from "class-validator";
import { FieldType } from "Core/Utils/Utils";
import { StoresInstance } from "Custom/Stores/Stores";
import { AccountStore, ErrorStore } from "Custom/Stores/Domain";
import { DomainStores } from "Custom/Stores";

export default class ResetViewModel extends ViewModelBase {
    isFieldValid(fieldName: never, value: any): boolean {
        throw new Error("Method not implemented.");
    }
    private domainStore: DomainStores = StoresInstance.domain;
    private accountStore: AccountStore = StoresInstance.domain.AccountStore;

    constructor() {
        super(null, false);
    }

    @computed
    public get showResetButton(): boolean {
        return this.domainStore.showResetButton;
    }

    @action
    public reset = async (): Promise<void> => {
        this.accountStore.resetUser();
    };

    // #region Viewmodel Boilerplate

    public afterUpdate: undefined;
    public beforeUpdate: undefined;

    // #endregion Viewmodel Boilerplate
}
